import { useTranslation } from "react-i18next"

import Heading from "@/globalComponents/atoms/Heading"
import Text from "@/globalComponents/atoms/Text"
import Modal from "@/globalComponents/molecules/Modal"

interface Props {
  isOpen: boolean
  onOpenChange: () => void
}

export function CancelConfirmedModal({ isOpen, onOpenChange }: Props) {
  const { t } = useTranslation("reserve")

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <Modal.Header>
        <Heading level={2} slot="title">
          {t("confirmation.cancellation")}
        </Heading>
      </Modal.Header>

      <Modal.Body>
        <Text level={2}>{t("confirmation.cancelConfirmedBody")}</Text>
      </Modal.Body>
    </Modal>
  )
}
